import { cx } from '@linaria/core'
import React, { FC } from 'react'
import * as styles from './styles'

type GradientBackgroundProps = {
  variant: number
}

const variantToString = ['first', 'second', 'third']

export const GradientBackground: FC<GradientBackgroundProps> = ({ variant }) => {
  const variantString = variantToString[variant % 3]

  return (
    <div className={cx(styles.outerContainer, styles[`${variantString}VariantOuterContainer`])}>
      <div className={styles.container}>
        <span className={cx(styles.circle, styles[`${variantString}VariantFirstCircle`])} />
        <span className={cx(styles.circle, styles[`${variantString}VariantSecondCircle`])} />
      </div>
    </div>
  )
}
